import {NavLink as ReactRouterLink} from 'react-router-dom';
import Link from "@material-ui/core/Link";
import React from "react";

const RouterLink = ({children, underline = 'none', component = ReactRouterLink, hasError = false, ...rest}) => {
    if (hasError) {
        return null;
    }

    return (
        <Link color='inherit' underline={underline} {...rest} component={component}>{children}</Link>
    );
}

export default RouterLink;
